export interface DeleteCommitteeInput {
  foundationId: string;
  committeeId: string;
}
